import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const RunIssuesPage = lazy(() => import('~/features/catalog-v2/pages/run-issues-page'));

/** A batch's Issues tab — its failed / still-flagged rows grouped by stage + reason. */
export const Route = createFileRoute('/_authenticated/_tenant/catalog-v2/runs/$runId/issues')({
  component: RouteComponent,
});

function RouteComponent() {
  const { runId } = Route.useParams();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <RunIssuesPage runId={runId} />
    </Suspense>
  );
}
